import * as React from "react";
export const FilterSearchIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={43} height={44} viewBox="0 0 43 44" {...props}>
      <path
        fill="#6d7278"
        d="M34 17C34 20.88 32.68 24.42 30.5 27.28L42.63 39.38L38.38 43.63L26.09 31.34C23.46 33.02 20.36 34 17 34C7.6 34 0 26.4 0 17C0 7.6 7.6 0 17 0C26.4 0 34 7.6 34 17ZM4 17C4 24.2 9.8 30 17 30C24.2 30 30 24.2 30 17C30 9.8 24.2 4 17 4C9.8 4 4 9.8 4 17Z"
      />
    </svg>
  );
};
